import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { DataList, Alert } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private apiService: ApiService) {}

  list(is_read: string = ''): Observable<DataList<Alert>> {
    return this.apiService.get<DataList<Alert>>(`user/notifications?${is_read}`).pipe();
  }

  show(id: number): Observable<Alert> {
    return this.apiService.get<Alert>(`user/notifications/${id}`).pipe();
  }

  read(id: number): Observable<{ message: string }> {
    return this.apiService.put<{ message: string }>(`user/notifications/${id}`, {}).pipe();
  }

  readBulk(entries: number[]): Observable<{ message: string }> {
    return this.apiService.put<{ message: string }>(`user/notifications/bulk`, { entries: entries }).pipe();
  }

  delete(id: number): Observable<{ message: string }> {
    return this.apiService.delete<{ message: string }>(`user/notifications/${id}`).pipe();
  }

  deleteBulk(entries: string): Observable<{ message: string }> {
    return this.apiService.delete<{ message: string }>(`user/notifications/bulk?${entries}`).pipe();
  }
}
